import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import routes from "./routes";
import withTracker from "./withTracker";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/main.scss";

import { logout } from "./components/auth/UserFunctions";

require("dotenv").config();

const PrivateRoute = ({ component: Component, roles, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const user_roles = JSON.parse(localStorage.getItem("userRoles"));
      var expires_at = new Date(localStorage.getItem("expires_at"));
      var dt = new Date();
      const expired = dt.getTime() > expires_at.getTime() ? true : false;
      if (expired) {
        return <Redirect to={{ pathname: "token-expired" }} />;
      }

      //const user_roles = ['super-admin']
      if (!user_roles) {
        logout();
      }
      var found = false;
      roles.map((val, idx) => {
        user_roles.map((val2, idx) => {
          if (val2.name === val) {
            found = true;
          }
        });
        //          found = found || user_roles.some(r => roles.includes(val))
      });
      // check if route is restricted by role
      if (!found) {
        return <Redirect to={{ pathname: "forbidden" }} />;
      }
      // authorised so return component
      return <Component {...props} />;
    }}
  />
);

export default () => {
  const DEV = process.env.REACT_APP_DEV || 1;
  if (parseInt(DEV) !== 1) {
    console.log = console.warn = console.error = () => {};
  }
  return (
    <BrowserRouter>
      <Switch>
        {routes.map((route, index) => {
          if (route.private) {
            return (
              <PrivateRoute
                key={index}
                path={route.path}
                exact={route.exact}
                roles={route.roles}
                component={withTracker(props => {
                  return (
                    <route.layout {...props}>
                      <route.component {...props} />
                    </route.layout>
                  );
                })}
              />
            );
          } else {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={withTracker(props => {
                  return (
                    <route.layout {...props}>
                      <route.component {...props} />
                    </route.layout>
                  );
                })}
              />
            );
          }
        })}
      </Switch>
    </BrowserRouter>
  );
};
